import { render } from "./PrivacyFrom.vue?vue&type=template&id=fe8c7266&scoped=true"
import script from "./PrivacyFrom.vue?vue&type=script&lang=js"
export * from "./PrivacyFrom.vue?vue&type=script&lang=js"

import "./PrivacyFrom.vue?vue&type=style&index=0&id=fe8c7266&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe8c7266"]])

export default __exports__